function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 58C12.984 58 0 45.016 0 29S12.984 0 29 0s29 12.984 29 29-12.984 29-29 29zm0 0",
  fill: "#d8d9d8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29 .965C13.52.965.965 13.52.965 29S13.52 57.035 29 57.035 57.035 44.48 57.035 29 44.48.965 29 .965zm0 0",
  fill: "#d8d9d8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.984 21.992h5.606v21.024h-5.606zm2.786-2.805h-.032c-1.672 0-2.754-1.246-2.754-2.804 0-1.59 1.114-2.801 2.817-2.801 1.707 0 2.758 1.211 2.789 2.8 0 1.56-1.082 2.805-2.82 2.805zM44.418 29.7a7.705 7.705 0 00-14.016-4.422v-3.285h-5.605v21.024h5.605V31.805a4.205 4.205 0 118.41 0v11.21h5.606V29.7zm0 0",
  fill: "#fff"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58pt",
    height: "58pt",
    viewBox: "0 0 58 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.242919b0.svg";
export { ForwardRef as ReactComponent };